import { mq } from "@/constants/breakpoints";
import {
  blueColor,
  darkColor,
  lightBlueColor,
  mutedBlueColor,
  textColor,
} from "@/constants/colors";
import { helpCenterPath } from "@/constants/paths";
import ArrowLeftIcon from "@/svg/ArrowLeftIcon";
import { css } from "@emotion/react";
import Image from "next/image";
import Link from "next/link";
import mailIcon from "../../../public/images/about/mail.svg";
import { BodyMedium14, H6Css, H7Css, Heading } from "../Typography";

interface HelpSectionProps {}

const HelpSection = ({}: HelpSectionProps) => {
  return (
    <div
      css={css`
        display: flex;
        margin-top: 60px;
        flex-direction: column;
        gap: 16px;
        ${mq["md"]} {
          margin-top: 120px;
          flex-direction: row;
        }
      `}
    >
      <div
        css={css`
          flex: 1;
          padding: 75px 24px 60px;
          background-color: ${mutedBlueColor};
          text-align: center;
          border-radius: 12px;
        `}
      >
        <Image src={mailIcon} alt="Support Icon" />
        <Heading
          css={css`
            color: ${darkColor};
            margin-top: 50px;
            ${H6Css}
          `}
        >
          Need help?
        </Heading>
        <BodyMedium14
          css={css`
            margin-top: 8px;
            max-width: 337px;
            margin: 8px auto 0;
            color: ${textColor};
          `}
        >
          Need help with your website, online registration or just figuring out
          which plan is best for you?
        </BodyMedium14>
      </div>
      <div
        css={css`
          flex: 1;
        `}
      >
        <div
          css={css`
            background-color: ${mutedBlueColor};
            padding: 22px 24px;
          `}
        >
          <BodyMedium14
            css={css`
              color: ${textColor};
              border-radius: 12px;
            `}
          >
            We handle all customer support via email to keep your account
            secure. We&apos;ll send screenshots, videos, and links to help you
            get your site up and running.
          </BodyMedium14>
          <Heading
            css={css`
              color: ${darkColor};
              margin-top: 40px;
              text-align: center;
              font-weight: 400;
              font-size: 16px;
              line-height: 130%;
            `}
          >
            Contact our Customer Care team:
          </Heading>
          <div
            css={css`
              margin-top: 20px;
              background-color: #e7efff;
              text-align: center;
              border-radius: 8px;
            `}
          >
            <Link
              href="mailto:help@jerseywatch.com"
              css={css`
                color: ${lightBlueColor};
                transition: color 0.2s ease-in-out;
                &:hover {
                  color: #45abe7;
                }
              `}
            >
              <Heading
                css={css`
                  padding: 24px;
                  ${H7Css}
                `}
              >
                help@jerseywatch.com
              </Heading>
            </Link>
          </div>
        </div>
        <Link href={helpCenterPath}>
          <div
            css={css`
              margin-top: 16px;
              border: 2px solid ${blueColor};
              text-align: center;
              border-radius: 8px;
              padding: 22px 24px;
              border-radius: 12px;
              display: flex;
              gap: 14px;
              transition: background-color 0.2s ease-in-out;
              &:hover {
                background-color: ${mutedBlueColor};
              }
            `}
          >
            <BodyMedium14
              css={css`
                color: ${textColor};
              `}
            >
              Prefer to learn on your own? We also have quick video tutorials in
              our{" "}
              <span
                css={css`
                  color: ${lightBlueColor};
                `}
              >
                Help Center
              </span>
              .
            </BodyMedium14>
            <ArrowLeftIcon
              css={css`
                transform: rotate(180deg);
                min-width: 36px;
                height: auto;
                color: ${lightBlueColor};
              `}
            />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default HelpSection;
